import { Button, ButtonProps } from "react-bootstrap";
import OverlaySpinner from "./OverlaySpinner";

export interface SpinnerButtonProps {
    className?: string;
    label: string;
    isLoading: boolean;
    buttonProps: Omit<ButtonProps, "as">;
}

function SpinnerButton(props: SpinnerButtonProps) {
    const className = props.className ?? "";
    const disabled = (props.buttonProps?.disabled ?? false) || props.isLoading;
    // Separate containers required to prevent weird CSS interactions
    return (
        <div className={className}>
            <div className="position-relative">
                <Button {...props.buttonProps} disabled={disabled}>
                    <OverlaySpinner size="sm" isLoading={props.isLoading} />
                    {props.label}
                </Button>
            </div>
        </div>
    );
}

export default SpinnerButton;
